import { z } from 'zod'
import { schemaHelpers } from './QiagenManagerHelpers'

const {
  requiredDate,
  requiredSelect
} = schemaHelpers

export const QiagenManagerFormSchema = z
  .object({
    sampleDate: requiredDate,
    sampleName: requiredSelect
  })
